import React from 'react';
import Linkify from './Linkify';

/** 최종 결과물의 한 장 요약 [{ q, a }] — 버전 카드 · Lead inbox 공용 */
export const OnePageView = ({ items }) => (
  <div className='flex flex-col gap-2 rounded-xl bg-green-deep03/[0.03] px-4 py-3'>
    <span className='text-[12px] font-medium text-text-secondary'>One-page summary</span>
    {items.map((it) => (
      <div key={it.q} className='flex flex-col gap-0.5'>
        <span className='text-[13px] font-medium text-text-primary'>{it.q}</span>
        <p className='whitespace-pre-line text-[13px] leading-[150%] text-text-secondary'><Linkify text={it.a} /></p>
      </div>
    ))}
  </div>
);
